"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.getUserImageUrl = void 0;

var getUserImageUrl = function getUserImageUrl(userImage) {
  return userImage && userImage.image ? "data:image/jpeg;base64,".concat(userImage.image) : '';
};

exports.getUserImageUrl = getUserImageUrl;